var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-Char"},[(_vm.showChart)?_c('BarChart',{staticStyle:{"min-height":"250px","height":"250px"},attrs:{"chartdata":_vm.chartData,"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }